import { n as e, t } from "./BlockNoteExtension-BXhE27K9.js";
import { t as n } from "./ShowSelection-S5WeiRyI.js";
import { t as r } from "./EventEmitter-CuPnGDYt.js";
import { Mark as i, mergeAttributes as a } from "@tiptap/core";
import { Plugin as o, PluginKey as s } from "prosemirror-state";
import { uuidv4 as c } from "lib0/random";
import { Decoration as l, DecorationSet as u } from "prosemirror-view";
import { getRelativeSelection as d, ySyncPluginKey as f } from "y-prosemirror";
import * as p from "yjs";
//#region src/comments/mark.ts
var m = i.create({
	name: "comment",
	excludes: "",
	inclusive: !1,
	keepOnSplit: !0,
	addAttributes() {
		return {
			orphan: {
				parseHTML: (e) => !!e.getAttribute("data-orphan"),
				renderHTML: (e) => e.orphan ? { "data-orphan": "true" } : {},
				default: !1
			},
			threadId: {
				parseHTML: (e) => e.getAttribute("data-bn-thread-id"),
				renderHTML: (e) => ({ "data-bn-thread-id": e.threadId }),
				default: ""
			}
		};
	},
	renderHTML({ HTMLAttributes: e }) {
		return ["span", a(e, { class: "bn-thread-mark" })];
	},
	parseHTML() {
		return [{ tag: "span.bn-thread-mark" }];
	},
	extendMarkSchema(e) {
		return e.name === "comment" ? { blocknoteIgnore: !0 } : {};
	}
}), h = class extends r {
	userCache = /* @__PURE__ */ new Map();
	loadingUsers = /* @__PURE__ */ new Set();
	constructor(e) {
		super(), this.resolveUsers = e;
	}
	async loadUsers(e) {
		let t = e.filter((e) => !this.userCache.has(e) && !this.loadingUsers.has(e));
		if (t.length !== 0) {
			for (let e of t) this.loadingUsers.add(e);
			try {
				let e = await this.resolveUsers(t);
				for (let t of e) this.userCache.set(t.id, t);
				this.emit("update", this.userCache);
			} finally {
				for (let e of t) this.loadingUsers.delete(e);
			}
		}
	}
	getUser(e) {
		return this.userCache.get(e);
	}
	subscribe(e) {
		return this.on("update", e);
	}
}, g = new s("blocknote-comments");
function _(e, t) {
	let n = /* @__PURE__ */ new Map();
	return e.descendants((e, r) => {
		e.marks.forEach((i) => {
			if (i.type.name === t) {
				let t = i.attrs.threadId;
				if (!t) return;
				let a = r, o = a + e.nodeSize, s = n.get(t) ?? {
					from: Infinity,
					to: 0
				};
				n.set(t, {
					from: Math.min(a, s.from),
					to: Math.max(o, s.to)
				});
			}
		});
	}), n;
}
var v = t(({ editor: t, options: { schema: r, threadStore: i, resolveUsers: a } }) => {
	if (!a) throw Error("resolveUsers is required to be defined when using comments");
	if (!i) throw Error("threadStore is required to be defined when using comments");
	let s = m.name, c = new h(a), p = e({
		pendingComment: !1,
		selectedThreadId: void 0,
		threadPositions: /* @__PURE__ */ new Map()
	}, { onUpdate() {
		p.state.selectedThreadId !== p.prevState.selectedThreadId && t.transact((e) => e.setMeta(g, !0));
	} }), v = (e) => {
		t.transact((t) => {
			t.doc.descendants((n, r) => {
				n.marks.forEach((i) => {
					if (i.type.name === s) {
						let a = i.type, o = i.attrs.threadId, s = e.get(o), c = !!(!s || s.resolved || s.deletedAt);
						if (c !== i.attrs.orphan) {
							let e = Math.max(r, 0), s = Math.min(r + n.nodeSize, t.doc.content.size - 1, t.doc.content.size - 1);
							t.removeMark(e, s, i), t.addMark(e, s, a.create({
								...i.attrs,
								orphan: c
							})), c && p.state.selectedThreadId === o && p.setState((e) => ({
								...e,
								selectedThreadId: void 0
							}));
						}
					}
				});
			});
		});
	};
	return {
		key: "comments",
		store: p,
		prosemirrorPlugins: [new o({
			key: g,
			state: {
				init() {
					return { decorations: u.empty };
				},
				apply(e, t) {
					let n = e.getMeta(g);
					if (!e.docChanged && !n) return t;
					let r = e.docChanged ? _(e.doc, s) : p.state.threadPositions;
					(r.size > 0 || p.state.threadPositions.size > 0) && p.setState((e) => ({
						...e,
						threadPositions: r
					}));
					let i = [];
					if (p.state.selectedThreadId) {
						let e = r.get(p.state.selectedThreadId);
						e && i.push(l.inline(e.from, e.to, { class: "bn-thread-mark-selected" }));
					}
					return { decorations: u.create(e.doc, i) };
				}
			},
			props: {
				decorations(e) {
					return g.getState(e)?.decorations ?? u.empty;
				},
				handleClick: (e, t, n) => {
					if (n.button !== 0) return;
					let r = e.state.doc.nodeAt(t);
					if (!r) {
						p.setState((e) => ({
							...e,
							selectedThreadId: void 0
						}));
						return;
					}
					let i = r.marks.find((e) => e.type.name === s && e.attrs.orphan !== !0)?.attrs.threadId;
					i !== p.state.selectedThreadId && p.setState((e) => ({
						...e,
						selectedThreadId: i
					}));
				}
			}
		})],
		threadStore: i,
		mount() {
			let e = i.subscribe(v);
			v(i.getThreads());
			let n = t.onSelectionChange(() => {
				p.state.pendingComment && p.setState((e) => ({
					...e,
					pendingComment: !1
				}));
			});
			return () => {
				e(), n();
			};
		},
		selectThread(e, n = !0) {
			if (p.state.selectedThreadId !== e && (p.setState((t) => ({
				...t,
				pendingComment: !1,
				selectedThreadId: e
			})), e && n)) {
				let n = p.state.threadPositions.get(e);
				if (!n) return;
				(t.prosemirrorView?.domAtPos(n.from).node)?.scrollIntoView({
					behavior: "smooth",
					block: "center"
				});
			}
		},
		startPendingComment() {
			p.setState((e) => ({
				...e,
				selectedThreadId: void 0,
				pendingComment: !0
			})), t.domElement?.focus(), t.getExtension(n)?.showSelection(!0, "comments");
		},
		stopPendingComment() {
			p.setState((e) => ({
				...e,
				selectedThreadId: void 0,
				pendingComment: !1
			})), t.getExtension(n)?.showSelection(!1, "comments");
		},
		async createThread(e) {
			let n = await i.createThread(e);
			if (i.addThreadToDocument) {
				let e = t.prosemirrorView, r = e.state.selection, a = f.getState(e.state), o = {
					prosemirror: {
						head: r.head,
						anchor: r.anchor
					},
					yjs: a ? d(a.binding, e.state) : void 0
				};
				await i.addThreadToDocument({
					threadId: n.id,
					selection: o
				});
			} else t._tiptapEditor.commands.setMark(s, {
				orphan: !1,
				threadId: n.id
			});
		},
		userStore: c,
		commentEditorSchema: r,
		tiptapExtensions: [m]
	};
}), y = class {}, b = class extends y {
	constructor(e, t) {
		super(), this.userId = e, this.role = t;
	}
	canCreateThread() {
		return !0;
	}
	canAddComment(e) {
		return !0;
	}
	canUpdateComment(e) {
		return e.userId === this.userId;
	}
	canDeleteComment(e) {
		return e.userId === this.userId || this.role === "editor";
	}
	canDeleteThread(e) {
		return this.role === "editor";
	}
	canResolveThread(e) {
		return !0;
	}
	canUnresolveThread(e) {
		return !0;
	}
	canAddReaction(e, t) {
		return t ? !e.reactions.some((e) => e.emoji === t && e.userIds.includes(this.userId)) : !0;
	}
	canDeleteReaction(e, t) {
		return t ? e.reactions.some((e) => e.emoji === t && e.userIds.includes(this.userId)) : !0;
	}
}, x = class {
	auth;
	constructor(e) {
		this.auth = e;
	}
}, S = class extends x {
	constructor(e, t, n) {
		super(n), this.userId = e, this.provider = t;
	}
	async createThread(e) {
		let t = this.provider.createThread({ data: e.metadata });
		return t = this.provider.addComment(t.id, {
			content: e.initialComment.body,
			data: {
				metadata: e.initialComment.metadata,
				userId: this.userId
			}
		}), this.tiptapThreadToThreadData(t);
	}
	addThreadToDocument = void 0;
	async addComment(e) {
		let t = this.provider.addComment(e.threadId, {
			content: e.comment.body,
			data: {
				metadata: e.comment.metadata,
				userId: this.userId
			}
		});
		return this.tiptapCommentToCommentData(t.comments[t.comments.length - 1]);
	}
	async updateComment(e) {
		let t = this.provider.getThreadComment(e.threadId, e.commentId, !0);
		if (!t) throw Error("Comment not found");
		this.provider.updateComment(e.threadId, e.commentId, {
			content: e.comment.body,
			data: {
				...t.data,
				metadata: e.comment.metadata
			}
		});
	}
	tiptapCommentToCommentData(e) {
		let t = [];
		for (let n of e.data?.reactions || []) {
			let e = t.find((e) => e.emoji === n.emoji);
			e ? (e.userIds.push(n.userId), e.createdAt = new Date(Math.min(e.createdAt.getTime(), n.createdAt))) : t.push({
				emoji: n.emoji,
				createdAt: new Date(n.createdAt),
				userIds: [n.userId]
			});
		}
		return {
			type: "comment",
			id: e.id,
			body: e.content,
			metadata: e.data?.metadata,
			userId: e.data?.userId,
			createdAt: new Date(e.createdAt),
			updatedAt: new Date(e.updatedAt),
			reactions: t
		};
	}
	tiptapThreadToThreadData(e) {
		return {
			type: "thread",
			id: e.id,
			comments: e.comments.map((e) => this.tiptapCommentToCommentData(e)),
			resolved: !!e.resolvedAt,
			metadata: e.data?.metadata,
			createdAt: new Date(e.createdAt),
			updatedAt: new Date(e.updatedAt)
		};
	}
	async deleteComment(e) {
		this.provider.deleteComment(e.threadId, e.commentId);
	}
	async deleteThread(e) {
		this.provider.deleteThread(e.threadId);
	}
	async resolveThread(e) {
		this.provider.updateThread(e.threadId, { resolvedAt: (/* @__PURE__ */ new Date()).toISOString() });
	}
	async unresolveThread(e) {
		this.provider.updateThread(e.threadId, { resolvedAt: null });
	}
	async addReaction(e) {
		let t = this.provider.getThreadComment(e.threadId, e.commentId, !0);
		if (!t) throw Error("Comment not found");
		this.provider.updateComment(e.threadId, e.commentId, { data: {
			...t.data,
			reactions: [...t.data?.reactions || [], {
				emoji: e.emoji,
				createdAt: Date.now(),
				userId: this.userId
			}]
		} });
	}
	async deleteReaction(e) {
		let t = this.provider.getThreadComment(e.threadId, e.commentId, !0);
		if (!t) throw Error("Comment not found");
		this.provider.updateComment(e.threadId, e.commentId, { data: {
			...t.data,
			reactions: (t.data?.reactions || []).filter((t) => t.emoji !== e.emoji && t.userId !== this.userId)
		} });
	}
	getThread(e) {
		let t = this.provider.getThread(e);
		if (!t) throw Error("Thread not found");
		return this.tiptapThreadToThreadData(t);
	}
	getThreads() {
		return new Map(this.provider.getThreads().map((e) => [e.id, this.tiptapThreadToThreadData(e)]));
	}
	subscribe(e) {
		let t = () => {
			e(this.getThreads());
		};
		return this.provider.watchThreads(t), () => {
			this.provider.unwatchThreads(t);
		};
	}
};
//#endregion
//#region src/comments/threadstore/yjs/yjsHelpers.ts
function C(e) {
	let t = new p.Map();
	if (t.set("id", e.id), t.set("userId", e.userId), t.set("createdAt", e.createdAt.getTime()), t.set("updatedAt", e.updatedAt.getTime()), e.deletedAt ? (t.set("deletedAt", e.deletedAt.getTime()), t.set("body", void 0)) : t.set("body", e.body), e.reactions.length > 0) throw Error("Reactions should be empty in commentToYMap");
	return t.set("reactionsByUser", new p.Map()), t.set("metadata", e.metadata), t;
}
function w(e) {
	let t = new p.Map();
	t.set("id", e.id), t.set("createdAt", e.createdAt.getTime()), t.set("updatedAt", e.updatedAt.getTime());
	let n = new p.Array();
	return n.push(e.comments.map((e) => C(e))), t.set("comments", n), t.set("resolved", e.resolved), t.set("resolvedUpdatedAt", e.resolvedUpdatedAt?.getTime()), t.set("resolvedBy", e.resolvedBy), t.set("metadata", e.metadata), t;
}
function T(e) {
	return {
		emoji: e.get("emoji"),
		createdAt: new Date(e.get("createdAt")),
		userId: e.get("userId")
	};
}
function E(e) {
	return [...e.values()].map((e) => T(e)).reduce((e, t) => {
		let n = e.find((e) => e.emoji === t.emoji);
		return n ? (n.userIds.push(t.userId), n.createdAt = new Date(Math.min(n.createdAt.getTime(), t.createdAt.getTime()))) : e.push({
			emoji: t.emoji,
			createdAt: t.createdAt,
			userIds: [t.userId]
		}), e;
	}, []);
}
function D(e) {
	return {
		type: "comment",
		id: e.get("id"),
		userId: e.get("userId"),
		createdAt: new Date(e.get("createdAt")),
		updatedAt: new Date(e.get("updatedAt")),
		deletedAt: e.get("deletedAt") ? new Date(e.get("deletedAt")) : void 0,
		reactions: E(e.get("reactionsByUser")),
		metadata: e.get("metadata"),
		body: e.get("body")
	};
}
function O(e) {
	return {
		type: "thread",
		id: e.get("id"),
		createdAt: new Date(e.get("createdAt")),
		updatedAt: new Date(e.get("updatedAt")),
		comments: (e.get("comments") || []).map((e) => D(e)),
		resolved: e.get("resolved"),
		resolvedUpdatedAt: new Date(e.get("resolvedUpdatedAt")),
		resolvedBy: e.get("resolvedBy"),
		metadata: e.get("metadata")
	};
}
//#endregion
//#region src/comments/threadstore/yjs/YjsThreadStoreBase.ts
var k = class extends x {
	constructor(e, t) {
		super(t), this.threadsYMap = e;
	}
	getThread(e) {
		let t = this.threadsYMap.get(e);
		if (!t) throw Error("Thread not found");
		return O(t);
	}
	getThreads() {
		let e = /* @__PURE__ */ new Map();
		return this.threadsYMap.forEach((t, n) => {
			t instanceof p.Map && e.set(n, O(t));
		}), e;
	}
	subscribe(e) {
		let t = () => {
			e(this.getThreads());
		};
		return this.threadsYMap.observeDeep(t), () => {
			this.threadsYMap.unobserveDeep(t);
		};
	}
}, A = class extends k {
	constructor(e, t, n, r) {
		super(n, r), this.BASE_URL = e, this.headers = t;
	}
	doRequest = async (e, t, n) => {
		let r = await fetch(`${this.BASE_URL}${e}`, {
			method: t,
			body: JSON.stringify(n),
			headers: {
				"Content-Type": "application/json",
				...this.headers
			}
		});
		if (!r.ok) throw Error(`Failed to ${t} ${e}: ${r.statusText}`);
		return r.json();
	};
	addThreadToDocument = async (e) => {
		let { threadId: t, ...n } = e;
		return this.doRequest(`/${t}/addToDocument`, "POST", n);
	};
	createThread = async (e) => this.doRequest("", "POST", e);
	addComment = (e) => {
		let { threadId: t, ...n } = e;
		return this.doRequest(`/${t}/comments`, "POST", n);
	};
	updateComment = (e) => {
		let { threadId: t, commentId: n, ...r } = e;
		return this.doRequest(`/${t}/comments/${n}`, "PUT", r);
	};
	deleteComment = (e) => {
		let { threadId: t, commentId: n, ...r } = e;
		return this.doRequest(`/${t}/comments/${n}?soft=${!!r.softDelete}`, "DELETE");
	};
	deleteThread = (e) => this.doRequest(`/${e.threadId}`, "DELETE");
	resolveThread = (e) => this.doRequest(`/${e.threadId}/resolve`, "POST");
	unresolveThread = (e) => this.doRequest(`/${e.threadId}/unresolve`, "POST");
	addReaction = (e) => {
		let { threadId: t, commentId: n, ...r } = e;
		return this.doRequest(`/${t}/comments/${n}/reactions`, "POST", r);
	};
	deleteReaction = (e) => this.doRequest(`/${e.threadId}/comments/${e.commentId}/reactions/${e.emoji}`, "DELETE");
}, j = class extends k {
	constructor(e, t, n) {
		super(t, n), this.userId = e;
	}
	transact = (e) => async (t) => this.threadsYMap.doc.transact(() => e(t));
	createThread = this.transact((e) => {
		if (!this.auth.canCreateThread()) throw Error("Not authorized");
		let t = /* @__PURE__ */ new Date(), n = {
			type: "comment",
			id: c(),
			userId: this.userId,
			createdAt: t,
			updatedAt: t,
			reactions: [],
			metadata: e.initialComment.metadata,
			body: e.initialComment.body
		}, r = {
			type: "thread",
			id: c(),
			createdAt: t,
			updatedAt: t,
			comments: [n],
			resolved: !1,
			metadata: e.metadata
		};
		return this.threadsYMap.set(r.id, w(r)), r;
	});
	addThreadToDocument = void 0;
	addComment = this.transact((e) => {
		let t = this.threadsYMap.get(e.threadId);
		if (!t) throw Error("Thread not found");
		if (!this.auth.canAddComment(O(t))) throw Error("Not authorized");
		let n = /* @__PURE__ */ new Date(), r = {
			type: "comment",
			id: c(),
			userId: this.userId,
			createdAt: n,
			updatedAt: n,
			deletedAt: void 0,
			reactions: [],
			metadata: e.comment.metadata,
			body: e.comment.body
		};
		return t.get("comments").push([C(r)]), t.set("updatedAt", (/* @__PURE__ */ new Date()).getTime()), r;
	});
	updateComment = this.transact((e) => {
		let t = this.threadsYMap.get(e.threadId);
		if (!t) throw Error("Thread not found");
		let n = M(t.get("comments"), (t) => t.get("id") === e.commentId);
		if (n === -1) throw Error("Comment not found");
		let r = t.get("comments").get(n);
		if (!this.auth.canUpdateComment(D(r))) throw Error("Not authorized");
		r.set("body", e.comment.body), r.set("updatedAt", (/* @__PURE__ */ new Date()).getTime()), r.set("metadata", e.comment.metadata);
	});
	deleteComment = this.transact((e) => {
		let t = this.threadsYMap.get(e.threadId);
		if (!t) throw Error("Thread not found");
		let n = M(t.get("comments"), (t) => t.get("id") === e.commentId);
		if (n === -1) throw Error("Comment not found");
		let r = t.get("comments").get(n);
		if (!this.auth.canDeleteComment(D(r))) throw Error("Not authorized");
		if (r.get("deletedAt")) throw Error("Comment already deleted");
		e.softDelete ? (r.set("deletedAt", (/* @__PURE__ */ new Date()).getTime()), r.set("body", void 0)) : t.get("comments").delete(n), t.get("comments").toArray().every((e) => e.get("deletedAt")) && (e.softDelete ? t.set("deletedAt", (/* @__PURE__ */ new Date()).getTime()) : this.threadsYMap.delete(e.threadId)), t.set("updatedAt", (/* @__PURE__ */ new Date()).getTime());
	});
	deleteThread = this.transact((e) => {
		if (!this.auth.canDeleteThread(O(this.threadsYMap.get(e.threadId)))) throw Error("Not authorized");
		this.threadsYMap.delete(e.threadId);
	});
	resolveThread = this.transact((e) => {
		let t = this.threadsYMap.get(e.threadId);
		if (!t) throw Error("Thread not found");
		if (!this.auth.canResolveThread(O(t))) throw Error("Not authorized");
		t.set("resolved", !0), t.set("resolvedUpdatedAt", (/* @__PURE__ */ new Date()).getTime()), t.set("resolvedBy", this.userId);
	});
	unresolveThread = this.transact((e) => {
		let t = this.threadsYMap.get(e.threadId);
		if (!t) throw Error("Thread not found");
		if (!this.auth.canUnresolveThread(O(t))) throw Error("Not authorized");
		t.set("resolved", !1), t.set("resolvedUpdatedAt", (/* @__PURE__ */ new Date()).getTime());
	});
	addReaction = this.transact((e) => {
		let t = this.threadsYMap.get(e.threadId);
		if (!t) throw Error("Thread not found");
		let n = M(t.get("comments"), (t) => t.get("id") === e.commentId);
		if (n === -1) throw Error("Comment not found");
		let r = t.get("comments").get(n);
		if (!this.auth.canAddReaction(D(r), e.emoji)) throw Error("Not authorized");
		let i = /* @__PURE__ */ new Date(), a = `${this.userId}-${e.emoji}`, o = r.get("reactionsByUser");
		if (!o.has(a)) {
			let t = new p.Map();
			t.set("emoji", e.emoji), t.set("createdAt", i.getTime()), t.set("userId", this.userId), o.set(a, t);
		}
	});
	deleteReaction = this.transact((e) => {
		let t = this.threadsYMap.get(e.threadId);
		if (!t) throw Error("Thread not found");
		let n = M(t.get("comments"), (t) => t.get("id") === e.commentId);
		if (n === -1) throw Error("Comment not found");
		let r = t.get("comments").get(n);
		if (!this.auth.canDeleteReaction(D(r), e.emoji)) throw Error("Not authorized");
		let i = `${this.userId}-${e.emoji}`;
		r.get("reactionsByUser").delete(i);
	});
};
function M(e, t) {
	for (let n = 0; n < e.length; n++) if (t(e.get(n))) return n;
	return -1;
}
//#endregion
export { m as CommentMark, v as CommentsExtension, b as DefaultThreadStoreAuth, A as RESTYjsThreadStore, x as ThreadStore, y as ThreadStoreAuth, S as TiptapThreadStore, j as YjsThreadStore, k as YjsThreadStoreBase };

//# sourceMappingURL=comments.js.map